import { BsDatepickerViewMode } from 'ngx-bootstrap/datepicker';

export class LocaleStateModel {
  dateInputFormat: string = 'YYYY-MM-DD';   
  isAnimated: boolean = true;               
  showWeekNumbers: boolean = false;         
  minMode: BsDatepickerViewMode = 'day';  
  adaptivePosition: boolean = true;         
}